<template lang="html">
  <v-layout class="filter-content">
    <v-flex xs8 md2 class="mt-4">
      <span class="filter-text">
        Viewing {{ filterText }}
      </span>
    </v-flex>
    <v-flex xs2 class="mt-1">
      <span class="filter-actions">
        <v-dialog
          persistent
          v-model="filterDialog"
          :width="400"
          class="filter-composition">
          <template #activator="{ on }">
            <edit-btn v-on="on"/>
          </template>
          <!-- TODO EVENT HANDLERS -->
          <filter-card
            @save="filter"
            @close="filterDialog = false"/>
        </v-dialog>
        <clear-filter-btn
          v-if="!!filterType"
          @click="clear"/>
      </span>
    </v-flex>
  </v-layout>
</template>

<script>
import EditButton from './EditButton'
import ClearFilterButton from './ClearFilterButton'
import FilterCard from './FilterCard'

export default {
  components: {
    'edit-btn': EditButton,
    'clear-filter-btn': ClearFilterButton,
    'filter-card': FilterCard
  },
  props: {
    quotes: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },
  data: () => ({
    filterType: null,
    filterValue: null,
    filterDialog: false
  }),
  computed: {
    filterText () {
      const map = new Map([
        [ 'pickup', ' with pickup on: ' ],
        [ 'any', ' with any stop on: ' ],
        [ 'org', ' for organization: '],
        [ 'planner', ' for planner: ']
      ])
      if (!this.filterType) {
        return 'all quotes'
      }
      return 'quotes'.concat(map.get(this.filterType)).concat(this.filterValue)
    },
    indexedByName () {
      return this.createHashMap((quote, cb) => cb(
        quote.trip.trip_planner.name.toLowerCase(),
        quote
      ))
    },
    indexedByOrg () {
      return this.createHashMap((quote, cb) => cb(
        quote.trip.trip_planner.organization ? quote.trip.trip_planner.organization.toLowerCase() : null,
        quote
      ))
    },
    indexedByPickupDate () {
      return this.createHashMap((quote, cb) => cb(
        this.formatDate(new Date(quote.trip.stops.pickup.date)),
        quote
      ))
    },
    indexedByStopDate () {
      return this.createHashMap((quote, cb) => new Set([
        this.formatDate(new Date(quote.trip.stops.pickup.date)),
        ...quote.trip.stops.additionalStops.map(
          s => this.formatDate(new Date(s.date))
        )
      ]).forEach(key => cb(key, quote)))
    },
    activeFilter () {
      let filter;
      switch (this.filterType) {
        case 'org':
          filter = this.filterByOrganization;
          break;
        case 'planner':
          filter = this.filterByPlanner;
          break;
        case 'pickup':
          filter = this.filterByPickupDate;
          break;
        case 'any':
          filter = this.filterByAnyStopDate;
          break;
        default:
          filter = () => {};
          break;
      }
      return filter
    }
  },
  methods: {
    filter (p) {
      const { filterType, filterValue } = p
      this.filterType = filterType
      this.filterValue = filterValue
      this.filterDialog = false
      this.activeFilter()
    },
    filterByOrganization () {
      const org = this.filterValue.toLowerCase().trim()
      const filtered = this.indexedByOrg.get(org)
      this.$emit('filtered', filtered)
    },
    filterByPlanner () {
      const planner = this.filterValue.toLowerCase().trim()
      const filtered = this.indexedByName.get(planner)
      this.$emit('filtered', filtered)
    },
    filterByPickupDate () {
      const filtered = this.filterByDate(this.indexedByPickupDate)
      this.$emit('filtered', filtered)
    },
    filterByAnyStopDate () {
      const filtered = this.filterByDate(this.indexedByStopDate)
      this.$emit('filtered', filtered)
    },
    filterByDate (map) {
      const { days, startDate } = this.getDayRange()
      const result = [];
      for (let i = 0; i < days + 1; i++) {
        let date = new Date(startDate).setDate(startDate.getDate() + i);
        date = this.formatDate(new Date(date))
        if (map.has(date)) {
          result.push(new Set(map.get(date)))
        }
      }
      return [...new Set(
          result.reduce((arr, currSet) => arr.concat([...currSet]), [])
      )]
    },
    clear() {
      this.$emit('clear');
      this.filterType = null
      this.filterValue = null
    },
    createHashMap (cb) {
      const map = new Map()
      for (let i = 0; i < this.quotes.length; i++) {
        const quote = this.quotes[i]
        cb(quote, (key, val) => {
          if (map.has(key)) {
            const vals = map.get(key).slice()
            vals.push(val)
            map.set(key, vals)
          } else {
            map.set(key, [ val ])
          }
        })
      }
      return map
    },
    getDayRange () {
      const dates = this.filterValue.split(' to ').map(ds => new Date(ds))
      const timedelta = dates.reduceRight((acc, cv) => acc - cv)
      const msPerDay = 24 * 3600 * 1000
      let days = 0;
      if (typeof timedelta === 'number') {
        days = timedelta/msPerDay
      }
      return { days, startDate: new Date(dates[0]) }
    },
    formatDate (date) {
      const y = date.getFullYear()
      const m = date.getMonth() + 1
      const d = date.getDate()
      return ''.concat(m).concat('/').concat(d).concat('/').concat(y)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
